<div class="spinner" [ngStyle]="{ height: size + 'px', width: size + 'px' }"></div>
